module.exports = __webpack_public_path__ + "img/affida.eaccafe5.jpg";